import { Box, CircularProgress, Grid, Paper } from '@mui/material';
import classNames from 'classnames';
import React, { FC, useEffect, useState } from 'react';

import { useStyles } from './styles';

type CardUITProps = {
  onLoadData?: any;
  children?: any;
};

export const CardUIT: FC<CardUITProps> = ({ onLoadData, children }) => {
  const classes = useStyles();

  const [loading, setLoading] = useState(true);

  const initialize = () => {
    if (onLoadData) onLoadData(setLoading);
    else {
      setTimeout(() => {
        setLoading(false);
      }, 1000 * 1.5);
    }
  };

  useEffect(() => {
    initialize();
  }, []);

  return (
    <Paper className={loading ? classNames(classes.card, classes.cardCustomHeight) : classes.card}>
      {loading ? (
        <Grid container className={classes.loading}>
          <Box display={'flex'} width={'100%'} alignItems={'center'} justifyContent={'center'}>
            <CircularProgress className={classes.progress} />
          </Box>
        </Grid>
      ) : (
        <Box className={classes.cardBody}>
          <React.Fragment>{children}</React.Fragment>
        </Box>
      )}
    </Paper>
  );
};

export default CardUIT;
